<p-confirmDialog
  #deletionDialog
  key="deletionDialog-{{ this.tableData.pageId }}-{{ tableData.id }}">
  <ng-template pTemplate="headless">
    <ct-extraction-dialog
      acceptText="Bestätigen & Löschen"
      closeText="Abbrechen"
      title="Tabelle löschen"
      (acceptDialog)="acceptedDialog.emit(); deletionDialog.onAccept()"
      (closeDialog)="deletionDialog.onReject()">
      <p>Soll diese Tabelle gelöscht werden?</p>
    </ct-extraction-dialog>
  </ng-template>
</p-confirmDialog>
